import { render, staticRenderFns } from "./DmKalkulator.vue?vue&type=template&id=dcc19612&scoped=true&"
import script from "./DmKalkulator.vue?vue&type=script&lang=js&"
export * from "./DmKalkulator.vue?vue&type=script&lang=js&"
import style0 from "./DmKalkulator.vue?vue&type=style&index=0&id=dcc19612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc19612",
  null
  
)

export default component.exports